const TextFieldType = {
    TEXT: 0,
    EMAIL: 1,
    PHONE: 2
}
export default TextFieldType;